import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import '../../assets/css/bootstrap.min.css'
import '../../assets/plugins/fontawesome/css/fontawesome.min.css'
import '../../assets/plugins/fontawesome/css/all.min.css'
import '../../assets/css/bootstrap-datetimepicker.min.css'
import '../../assets/plugins/select2/css/select2.min.css'
import '../../assets/css/alertify.css'
import '../../assets/css/semantic.css'
import '../../assets/css/style.css'

const Layout = (props) => {

    var loadScript = function(src) {
        var tag = document.createElement('script');
        tag.async = false;
        tag.src = src;
        document.body.appendChild(tag);
    }

    loadScript('../../assets/js/jquery.min.js')
    loadScript('../../assets/js/popper.min.js')
    loadScript('../../assets/js/bootstrap.min.js')
    loadScript('../../assets/plugins/select2/js/select2.min.js')
    loadScript('../../assets/js/moment.min.js')
    loadScript('../../assets/js/bootstrap-datetimepicker.min.js')
    loadScript('../../assets/plugins/theia-sticky-sidebar/ResizeSensor.js')
    loadScript('../../assets/plugins/theia-sticky-sidebar/theia-sticky-sidebar.js')
    loadScript('../../assets/plugins/bootstrap-tagsinput/js/bootstrap-tagsinput.js')
    loadScript('../../assets/plugins/dropzone/dropzone.min.js')
    loadScript('../../assets/js/script.js')

    return ( 
        <div>
            <Header />
                {props.children}
            <Footer />
        </div>
    );
}
 
export default Layout;